import { createSelector } from 'reselect';
import { TimeFormatEnum } from 'types/graphql';
import { B2BLoginResponseUserObject } from 'store/reducers/auth/authReducer.types';
import { userSelector } from 'store/selectors/userSelectors/userSelector';
import isUserAgencySelector from 'store/selectors/userSelectors/isUserAgencySelector';

const isUserTimeFormat24hSelector = createSelector(
  userSelector,
  isUserAgencySelector,
  (user, isUserAgency) => {
    if (!user || isUserAgency) {
      return false;
    }

    const b2bUser = user as B2BLoginResponseUserObject;

    if (b2bUser.time_format === TimeFormatEnum.military) {
      return true;
    }

    return false;
  },
);

export default isUserTimeFormat24hSelector;
